import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "Do you offer free estimates?",
    a: "Yes. Every project starts with a free, no-pressure, on-site estimate. We'll measure your property, talk through your options, and give you clear pricing before you decide anything.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Dillon and serve all of Summit County within a roughly 30-mile radius — including Silverthorne, Frisco, Breckenridge, Keystone, Copper Mountain, and nearby communities.",
  },
  {
    q: "What types of fences do you install?",
    a: "Wood and cedar privacy fences, picket fences, chain link, aluminum and custom-designed fencing, plus construction and perimeter fencing. We also repair existing fences and install gates.",
  },
  {
    q: "How do your fences hold up to Colorado winters?",
    a: "That's our specialty. We set posts to a proper frost depth in well-drained footings and choose materials built for snow load, wind, and freeze-thaw cycles so your fence stays straight and solid.",
  },
  {
    q: "Can you repair my existing fence instead of replacing it?",
    a: "Often, yes. We reset leaning posts, replace damaged panels and pickets, and rebuild gates. We'll give you honest advice on whether a repair or a full replacement is the smarter option.",
  },
  {
    q: "Do you install gates and hardware?",
    a: "Absolutely — walk-through gates, rolling and swing drive gates, latches, hinges, and hardware, all sized and fitted to match your fence.",
  },
  {
    q: "How long does a fence installation take?",
    a: "It depends on the length, terrain, and material, but most residential fences are completed in a few days. We'll give you a realistic timeline with your estimate.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Estimates are always free, and we run a neighbor referral reward — when someone you refer books a fence with us, you both earn a reward.",
  },
];

const FAQSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-max max-w-3xl">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </motion.h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-6 data-[state=open]:shadow-md data-[state=open]:border-primary/20 transition-all"
              >
                <AccordionTrigger className="font-heading text-lg tracking-tight text-foreground hover:no-underline py-5 text-left font-semibold">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5 text-left">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
